export const SEO_DEFAULTS ={TITLE: "Strategic Sourcing", 
DESC: "Default description", 
KEYWORDS: "react, seo, default"}
